module.exports = __webpack_public_path__ + "img/siren.a43dd2b8.svg";